import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ServiceIcon = ({ id })=>/*#__PURE__*/ _jsxs("svg", {
        width: "97",
        height: "106",
        viewBox: "0 0 97 106",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M76.5867 56.4476C72.9536 48.9436 63.8368 45.9274 56.4451 49.7839L28.708 64.2554C23.8717 66.7787 20.8392 71.7814 20.8392 77.2364L20.8392 97.2154C20.8392 98.9484 22.6681 100.071 24.2136 99.2872L69.9707 76.0706C77.155 72.4255 80.0973 63.6986 76.5867 56.4476Z",
                fill: "url(#paint0_linear_2144_99615)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.9821 46.9781C25.5457 54.2846 34.368 57.3045 41.6615 53.7145L68.4328 40.5373C73.4381 38.0737 76.6084 32.9797 76.6084 27.4009L76.6084 7.71819C76.6084 6.00115 74.81 4.8774 73.2667 5.6301L28.7419 27.3463C21.454 30.9008 18.4276 39.6903 21.9821 46.9781Z",
                fill: "#F90667"
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint0_linear_2144_99615",
                    x1: "56.4315",
                    y1: "45.1785",
                    x2: "55.7007",
                    y2: "77.3751",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            "stop-color": "#EB024C",
                            "stop-opacity": "0.4"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            "stop-color": "#EB024C"
                        })
                    ]
                })
            })
        ]
    });
